import { render, staticRenderFns } from "./manufacturing-material-links.vue?vue&type=template&id=517dc020&scoped=true&"
import script from "./manufacturing-material-links.vue?vue&type=script&lang=js&"
export * from "./manufacturing-material-links.vue?vue&type=script&lang=js&"
import style0 from "./manufacturing-material-links.vue?vue&type=style&index=0&id=517dc020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517dc020",
  null
  
)

export default component.exports